import ModulesStateBasic from 'kts-scaffold-framework/modules/ModulesStateBasic';
import IPageMeta from 'kts-platform-frame/dataModel/IPageMeta';
import { UIListFilterState } from './UI.List.Filter';
// import ISettlement from 'src/dataModel/ISettlement';

/** 模块状态 */
export default class ModulesState extends ModulesStateBasic {
    receiptList: any;
    pageMeta: IPageMeta;
    inputSettlementDetail: any;
    detailInfo: any={};
    detailList: any;
    viewMatchList: any;
    matchedIdList: any=[];
    invoiceList: any=[]; //匹配页面，包含匹配的、未匹配的发票数据
    unmatchedInoviceList: any=[];
    matchedInvoiceList: any;
    matchedInvoiceId: any = [];
    supplierTaxId: number;
    listSelectedRows: any;
    matchSelectedRows: any;
    current: number;
    pageSize: number;
    fields: any;
    selectedRowKeys: any;
    filterDisplay: false;
    statistics: IStatistics = {
        amountMatchedTolerance: 0,
        amountMatchedTaxTolerance: 0,
        amountSum: 0,
        amountTax: 0,
        amountWithoutTax: 0,
        // matchedLength: number;
        // matchedAmountSum: number;
        // matchedAmountTax: number;            
        // matchedAmountWithoutTax: number;
        // diffAmountSum: number;
        // diffAmountTax: number;
        // diffAmountWithoutTax: number;
    };
    matchedAmountTax: number=0;
    matchedAmountWithoutTax: number=0;
    matchedAmountSum: number=0;
    matchedLength: number=0;

    uiListFilterState:UIListFilterState = new UIListFilterState();
}

interface IStatistics {
    amountWithoutTax: number;
    amountTax: number;
    amountSum: number;
    amountMatchedTolerance: number;
    amountMatchedTaxTolerance: number;
}



// WEBPACK FOOTER //
// ./src/display/apps/InputSettlement/Modules.State.ts